import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { SidebarComponent, SidebarMode } from './sidebar/sidebar.component';

declare var initFlowbite: any;

const SIDEBAR_STORAGE_KEY = 'lockdown_management.sidebar_mode';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  sidebarMode: SidebarMode = 'large';
  showShell = true;
  blocked = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.blocked = !this.isAllowedOrigin();
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateShellVisibility();
        if (isPlatformBrowser(this.platformId) && typeof initFlowbite === 'function') {
          setTimeout(() => initFlowbite(), 100);
        }
      });

    this.updateShellVisibility();

    if (isPlatformBrowser(this.platformId)) {
      const saved = sessionStorage.getItem(SIDEBAR_STORAGE_KEY);
      if (saved === 'small' || saved === 'large') {
        this.sidebarMode = saved;
      }
    }
  }

  onSidebarModeChange(mode: SidebarMode): void {
    this.sidebarMode = mode;
  }

  private isAllowedOrigin(): boolean {
    if (!environment.production) return true;
    if (window === window.top) return false;
    try {
      const allowed = new URL(environment.nSidePlatformUrl);
      const referrer = new URL(document.referrer);
      return referrer.hostname === allowed.hostname;
    } catch {
      return false;
    }
  }

  private updateShellVisibility(): void {
    let route = this.activatedRoute.root;
    while (route.firstChild) route = route.firstChild;
    this.showShell = route.snapshot.data['showShell'] !== false;
  }
}
